import React from 'react';

import { HorizontalSafeAreaContainer } from '../../../../components';
import { GroupOrderShareScreen } from '../../../../screens/GroupOrderShareScreen';

// ─────────────────────────────────────────────────────────────────────────────

export default function GroupOrderShareRoute() {
  return (
    <HorizontalSafeAreaContainer>
      <GroupOrderShareScreen />
    </HorizontalSafeAreaContainer>
  );
}
